import classNames from 'classnames'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {NullAsDefault, renderIf} from 'views/Shared'
import CourseClassContext from '../../CourseClassContext'
import CourseClassSubjects from '../CourseClassSubjects'
import CourseClassTeachers from '../CourseClassTeachers'
import {ItemInformation} from "../../../Organization/OrganizationEntity";
import {HeaderWithIconLine} from "../../../Templates/items/ListHeader";
import {FaUserTie} from "react-icons/fa6";
import {GoDotFill} from "react-icons/go";
import {DoubleValueItem} from "../../../CatholicHousehold/components/CatholicHouseholdComponents";
import {formatSimplifyDate} from "../../../../../helpers/dateUtils";
import _ from 'lodash'

const ListWrapper = ({style, title, className, children}) => (
    <div
        style={style}
        className={classNames('flex flex-col items-start space-y-6', className)}>
        <div className="w-full flex flex-col flex-1 gap-4">
            <HeaderWithIconLine
                icon={<FaUserTie size={18} className="text-color-500"/>}
                title={title}
                className="text-lg text-color-400"
            />
            <div className="ml-2 flex flex-col gap-4">
                {children}
            </div>
        </div>
    </div>
)

const CourseClassInformationTab = () => {
    const t = useTranslate()
    const {item, renderWarnings = NullAsDefault} = useContext(CourseClassContext)
    const {
        course,
        to_date,
        from_date,
        description,
        class_coordinator,
        number_of_students,
        class_teachers = [],
        class_subjects = [],
        coordinators = [],
    } = item ?? {}

    const warnings = Array.from(item?.warnings ?? [])

    const is_visitor = warnings.length

    if (is_visitor) {
        return (
            <div className="w-full flex flex-col gap-3">
                {renderWarnings(warnings)}
            </div>
        )
    }

    return renderIf(
        item,
        <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-2 mt-3">
                {renderIf(
                    description,
                    <span className="text-color-200 tracking-wide">{description}</span>
                )}
                <div className="flex flex-col gap-1 ml-2">
                    <div className="flex-1 items-baseline space-x-2">
                        <GoDotFill size={10} className="text-color-400"/>
                        <span className="text-xs md:text-sm text-color-500 italic">
                            {`${t('belongs to the course')} : `}
                        </span>
                        <Link
                            to={getLinkToDetail(course)}
                            className="font-bold text-base text-primary no-underline">
                            {getTitle(course)}
                        </Link>
                    </div>
                    {renderIf(
                        _.some([from_date, to_date]),
                        <DoubleValueItem
                            showIcon={true}
                            labelFirst="time"
                            valueFirst={formatSimplifyDate(from_date, 'medium')}
                            labelSecond={to_date ? ' - ' : ''}
                            valueSecond={to_date ? formatSimplifyDate(to_date, 'medium') : ''}
                            className="text-xs md:text-sm italic"
                        />
                    )}
                    <ItemInformation
                        showIcon={true}
                        label="number of student"
                        value={`${number_of_students} ${t('student')}`}
                        className="text-xs md:text-sm italic"
                    />
                    {renderIf(
                        coordinators?.length,
                        <div className="space-x-1 text-xs md:text-sm italic">
                            <GoDotFill size={10} className="text-color-400"/>
                            <span className="text-color-500 whitespace-no-wrap">{`${t('coordinators')} : `}</span>
                            {coordinators.map((e, i) => {
                                const {teacher} = e ?? {}
                                return (
                                    <span key={i} className="font-semibold text-color-000">
                                        {`${teacher?.prefix_title || ''} ${teacher?.fullname}`} {i < coordinators?.length - 1 && ', '}
                                    </span>
                                )
                            })}
                        </div>
                    )}
                </div>
            </div>
            {renderIf(
                class_subjects?.length > 0,
                <CourseClassSubjects item={item}/>
            )}
            {renderIf(
                class_teachers?.length > 0,
                <CourseClassTeachers
                    item={item}
                    renderList={({renderItem}) => (
                        <ListWrapper title="list of teachers">
                            {class_teachers.map(renderItem)}
                        </ListWrapper>
                    )}
                />
            )}
        </div>
    )
}

export default CourseClassInformationTab
